const getRawMobile = (mobile) => {
	if (!mobile) return;
	const length = mobile?.toString().length;
	return mobile?.toString().slice(length - 10, length);
};

export default getRawMobile;
